import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, HyattEvent } from "../../../services/index";
import { JGRNService } from "../../../services/jgrn.service";
import { PurchaseOrderService } from "../../../services/purchaseorder.service";
import {SalesInvoiceService } from "../../../services/index";
@Component({
  selector: "AddEditJGRN",
  templateUrl: "./AddEditJGRN.html",
})
export class AddEditJGRN {
  type: any;
  row: any;
  data: any;
  isLoadMask: Promise<any>;
  designdata: any = { indent_no: 0, rcvd_type_name: "" };
  jgrnData: any = {
    ref_no: "",
    party_name: "",
    jgrn_date: "",
    jgrn_type: "JOB WORK",
    inv_no: "",
    inv_date: "",
    style : "",
    brand : "",
    party_id : "",
    fab_no : "",
    total_mtr: 0,
    grand_total: 0,
  };
  isSaveDisabled : boolean = false;
  qualityList: any;
  colorList: any;
  codeList: any;
  poList: any;
  invList: any;
  widthList: any[];
  auto_number : number;
  styleList1: any;
  JGRNdata: any = {};
  varietyList = [];
  varietyList1 = [];
  brandList = ["JOB" ,"LEO BOYS", "OLIVE", "LE MERITIN", "MARX","EXPOSE"];
  jgrnList = ["JOB WORK"]
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  partyList: any;
  OdList: any;
  poNoList: any;
  design_no: any;
  lrList: any;
  LRList: any;
  design_auto_no: any;
  designList: any;
  isLoading: boolean = false;
  finyearList = [];
  designnoList: any;
  typeList: any = ["JOB WORK", "MATCHING", "RETURN", "OPENING"];
  typeList1: any;
  jgrnType: any = ["BULK", "BIT"];

  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];

    let jgrnData = Object.assign({}, val["data"]);
    this.jgrnData = jgrnData;
    if (this.mode == "Edit" || this.mode == "View") {
      this.loadeditJGRNList();
      // this.polist();
      //  this.getDesign(this.JGRNData.po_no);
      //    this.generateOdNo();

      // this.JGRNData.JGRN_date = this.formatDate(this.JGRNData.JGRN_date);

      // this.generateOdNo();
      // this.onEnterpono(this.JGRNData.po_no);
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("lrAuto") lrAuto;
  @ViewChild("jgrnTypes") jgrnTypes;
  @ViewChild("finAuto") finAuto;
  @ViewChild("poAuto") poAuto;
  @ViewChild("invAuto") invAuto;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("type1Auto") type1Auto;
  @ViewChild("shipAuto") shipAuto;
  @ViewChild("designAuto") designAuto;
  @ViewChild("colorAuto") colorAuto;
  @ViewChild("grntypeAuto") JGRNtypeAuto;

  widthCtrl: FormControl = new FormControl();
  designCtrl: FormControl = new FormControl();
  pdesignCtrl: FormControl = new FormControl();
  samTypeCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  JGRNControl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  poCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  lrCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  shipCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private combo: Combo2Service,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    public jgrn: JGRNService,
    public event: HyattEvent,
    private salesinvservice: SalesInvoiceService,

  ) {
    this.row = {
      party_design: "",
      shade: "",
      width: "",
      quality: "",
      type: "",
      mtr: 0,
      rate: 0,
      fab_design: "",
      fab_style: "",
      color: "",
      amount: 0,
      jgrnType : 'BULK',
      hsn_code : ""
    };
    this.data = {
      jgrnList: [],
    };
    let row = Object.assign({}, this.row);
    this.data.jgrnList.push(row);

    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
  }
  ngOnInit() {
    this.qualitylist();
    this.colorlist();
    this.codelist();
    this.tableScroll();
    this.typelist();
    this.styleList();

    if (this.mode == "Add") {
      this.jgrnData.jgrn_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      this.getAuto();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#grn_type").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");

      $("#" + nextEl).focus();
    }
  }
  onChangeJgrnType(jgrnType,ind){

    if((jgrnType != this.data.jgrnList[0]["jgrnType"]) && ind >= 1){

      swal({
        title: "Do you want to change all design to " + jgrnType + " ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Change all!",
        cancelButtonText: "No",
      }).then(() => {
        this.data.jgrnList.forEach(element => {
          element.jgrnType = jgrnType;
        });
      }).catch(() => {
        if(jgrnType == 'BULK'){
          this.data.jgrnList.forEach(element => {
            element.jgrnType = 'BIT';
          });
        }else if(jgrnType == 'BIT'){
          this.data.jgrnList.forEach(element => {
            element.jgrnType = 'BULK';
          });
        }
        // this.data.jgrnList[ind]['jgrnType'] = this.data.jgrnList[0]["jgrnType"];
        swal("Sorry...You can enter either enter Bit or Bulk at a time");
      });
    }else if(ind == 0){
      this.data.jgrnList.forEach(element => {
        element.jgrnType = jgrnType;
      });
    }

  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      party_design = this.data.jgrnList[ind]["party_design"],
      shade = this.data.jgrnList[ind]["shade"],
      quality = this.data.jgrnList[ind]["quality"],
      type = this.data.jgrnList[ind]["type"],
      width = this.data.jgrnList[ind]["width"],
      mtr = this.data.jgrnList[ind]["mtr"],
      //  width = this.data.designList[ind]['width'],
      rate = this.data.jgrnList[ind]["rate"],
      fab_style = this.data.jgrnList[ind]["fab_style"],
      fab_design = this.data.jgrnList[ind]["fab_design"],
      color = this.data.jgrnList[ind]["color"],
      jgrnType = this.data.jgrnList[ind]["jgrnType"];

    let nxtRow = $("#row-" + ind).next("tr");


    if ((party_design != "" && fab_design != "") || color != "") {
      if (fld == "partydesign" && nxtRow.length == 0) {
        if(!this.data.jgrnList[ind].hsn_code){
          swal("Please enter the hsn code!");
          return false;
        }
        for (let i = 0; i < this.data.jgrnList.length; i++) {
          if (ind + 1 == this.data.jgrnList.length) {
            let rowdetail = Object.assign({}, this.row);

            this.data.jgrnList.push(rowdetail);

            nxtInd = this.data.jgrnList.length - 1;
            this.data.jgrnList[ind + 1]["jgrnType"] = this.data.jgrnList[ind][
              "jgrnType"
            ];
          }
        }
      }
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  codelist() {
    // this.poservice.codelist({}).then((res: any) => {
    //   this.codeList = res.data;
    // });
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.codeList = res;
    });
  }

  oncheckemptyrow() {
    let jgrn = this.data.jgrnList;
    let jgrnList = [];
    for (let i = 0; i < jgrn.length; i++) {
      if(!jgrn[i].hsn_code) {
        swal("Please enter the hsn code!");
        return false;
      } else {
        if (jgrn[i].party_design != "") {
          jgrnList.push(jgrn[i]);
        }
      }
    }
    this.data.jgrnList = jgrnList;
    this.onSaveJGrn();
  }
  tableScroll() {
    $(".invscreen").height(window.innerHeight - 495);
    $(".JGRNbody").width(window.innerWidth - 30);
  }
  onDeleteRow($event, fld, ind) {
    if (this.data.JGRNList.length > 1) {
      this.data.JGRNList.splice(ind, 1);

      if ($("#" + fld + "-" + (ind - 1)).length > 0) {
        $("#" + fld + "-" + (ind - 1)).focus();
      } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
        $("#" + fld + "-" + (ind + 1)).focus();
      }
    }
    // this.calcTotal();
  }

  onclickpdcode(designshade, shade, ind) {
    this.data.jgrnList[ind].des_no = designshade;
    this.data.jgrnList[ind].p_shade = shade;
    let params = {
      pdesign_no: this.data.jgrnList[ind].des_no,
      shade: this.data.jgrnList[ind].p_shade,
    };
    let that = this;
    that.jgrn.getCoreList(params).then((res: any) => {
      if (res.success == true) {
        that.data.jgrnList[ind].design_type = res.data[0].type;
        that.data.jgrnList[ind].design_no = res.data[0].core_designno;
        that.data.jgrnList[ind].fab_design = res.data[0].core_designno;
        that.data.jgrnList[ind].type = res.data[0]["fabric_style"];
        // that.data.jgrnList[ind].shade = res.data[0]["fabric_color"];
        that.data.jgrnList[ind].style = res.data[0].fabric_style;
        that.data.jgrnList[ind].isNew = false;
        if(that.data.jgrnList[ind].shade != ''){
          swal("THIS IS A  " + this.data.jgrnList[ind].design_type + " DESIGN");
        }
      } else {
        that.data.jgrnList[ind].design_type = "NEW";
        that.onClickDesign(that.data.jgrnList[ind].des_no, ind);
      }
    });
  }
  styleList() {
    this.poservice.styleList({}).then((res: any) => {
      this.styleList1 = res.data;
    });
    this.combo.varietyStyleCombo().then((res: any) => {
      let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

    });
  }
  
  onClickDesign(designno, ind) {
    let des_no = this.data.jgrnList[ind].des_no;
    let design_shade = this.data.jgrnList[ind].pd_code;
    for (let i = 0; i < this.data.jgrnList.length; i++) {
      if (i != ind && designno == this.data.jgrnList[i].des_no) {
        let fab_design = this.data.jgrnList[i].fab_design;
        this.data.jgrnList[ind].fab_design = fab_design;


        if (this.data.jgrnList[i].isNew == true) {
          this.data.jgrnList[ind].isNew = false;
        }

        
        return;
      }
    }
       this.onTypeDesign(designno, ind);
  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    this.jgrn.getAuto({}).then((res: any) => {
      this.jgrnData.ref_no = res.ref_no;
      this.auto_number = res.auto_design;
    });
  }

  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }

  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList1 = res.data;
    });
  }
  Onselectparty(party) {
   let obj = [];
  //  let Data = this.jobpartyList.filter((el) => el.name == type)
  //  this.dcdata.jobparty_id = Data[0].genLedid;
   obj = this.codeList.filter(el=>el.name == party);
   console.log(obj);
   this.jgrnData.party_id = obj[0].genLedid;
  }
  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id + "" });
      if (!fitem) {
      }

      return fitem["finyear"];
    }
    return "";
  }

  calcAmount(ind) {
    let mtr = this.data.jgrnList[ind].mtr,
      rate = this.data.jgrnList[ind].rate,
      tot_mtr = 0,
      tot_amt = 0;
    this.data.jgrnList[ind].amount = (mtr * rate).toFixed(2);
    for (let i = 0; i < this.data.jgrnList.length; i++) {
      let jgrndata = this.data.jgrnList[i];
      tot_mtr += jgrndata.mtr;
      tot_amt += parseFloat(jgrndata.amount);
    }
    this.jgrnData.grand_total = Number(tot_amt.toFixed(2));
    this.jgrnData.total_mtr = tot_mtr.toFixed(2);
  }

  onTypeDesign(design, ind) {
    //  let des_no = this.data.jgrnList[ind].des_no;
    let party_design = this.data.jgrnList[ind].party_design;
    for (let i = 0; i < this.data.jgrnList.length; i++) {
      if (i != ind && design == this.data.jgrnList[i].party_design) {
        let fab_design = this.data.jgrnList[i].fab_design;
        this.data.jgrnList[ind].fab_design = fab_design;

        if (this.data.jgrnList[i].isNew == true) {
          this.data.jgrnList[ind].isNew = false;
        }

        return;
      }
    }
    // this.generateFabNo(party_design, ind);
  }
  // generateFabNo(party_design, ind) {
  //   let params = {
  //     party_design: party_design,
  //   };
  //   let that = this;
  //   that.jgrn.getAutoDesignNo(params).then((res: any) => {
  //     //  this.data.grnList[ind].design_no = res;
  //     that.data.jgrnList[ind].fab_design = that.isSameDesignNo(
  //       res.fab_design,
  //       ind,
  //       party_design,
  //       res.newExists
  //     );
  //   });
  // }

  isSameDesignNo(res, ind, party_design, newExists) {
    //
    for (let i = 0; i < this.data.jgrnList.length - 1; i++) {
      if (
        res == this.data.jgrnList[i].fab_design &&
        party_design != this.data.jgrnList[i].party_design
      ) {
        res = res + 1;
        this.isSameDesignNo(res, ind, party_design, newExists);
      }
    }
    if(Object.entries(newExists).length > 0 && party_design != '' && this.data.jgrnList[ind].shade != ''){
      swal({
        title : "LAST GENERATED DETAILS " + party_design + " - " + res,
        html: "JGRN NO : " + newExists.jgrn_no + "<br/>" +  " JGRN DATE : " + newExists.jgrn_date + "<br/>" + " INVOICE NO : " + newExists.invoice_no + "<br/>" + " INVOICE DATE : " + newExists.invoice_date  
      });
      this.data.jgrnList[ind].isNew = false;
    }else{
      this.data.jgrnList[ind].isNew = true;
    }
    return res;
  }

  onSaveJGrn(): void {
    if (
      this.jgrnData.inv_no == "" ||
      this.jgrnData.jgrn_type == "" ||
      this.jgrnData.party_name == "" ||
      !this.jgrnData.style ||
      !this.jgrnData.brand ||
      !this.jgrnData.fab_no ||
      !this.jgrnData.inv_date ||

      !(this.data.jgrnList.every(el => {
        return el.jgrnType != ''
      })) ||
      !(this.data.jgrnList.every(el => {
        return el.width != ''
      }))
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let params: any = Object.assign({}, this.jgrnData);
      params["tabevent"] = undefined;
      params["data"] = JSON.stringify(this.data);
      params["jgrn_date"] = this.datePipe.transform(
        params["jgrn_date"],
        "yyyy-MM-dd"
      );
      let that = this;

      swal({
        title: "Are you sure to save this JGRN?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isSaveDisabled = true;
        that.isLoading = true;
        that.jgrn
          .saveJgrn(params)
          .then(function (res: any) {
            that.isSaveDisabled = false;
            that.isLoading = false;
            if (that.saveEvent) {
              // that.saveEvent.emit();
            }
            that.event.jgrnSavedSource.next("saved");
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              swal({
                title: "Click YES for Sticker Print?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes!",
                cancelButtonText: "No",
              }).then(() => {
                that.loadeditJGRNPrintList(res.jgrn_id);
              }).catch(() => {
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                  that.saveEvent.emit();
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              });
            
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isSaveDisabled = true;
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  loadeditJGRNPrintList(jgrnid) {
    let params = {
      jgrn_id: jgrnid,
    };
    let that = this;
    that.jgrn.getEditJGRNList(params).then((res: any) => {
      that.data.jgrnList = res.data;
      var row  = res.data[0];
      // that.calcTotal();
      // that.calcQty();
      if(row.jgrnType == 'BIT'){
        swal({
          title: "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        });
      }else{
        swal({
          title: "Please ensure that large Sticker roll (Bulk Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        });
      }

      
    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn.jgrnprint(params).then(function (res: any) {
      if (that.mode == "Add") {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
        that.saveEvent.emit();
      } else {
        let tabObj = {
          action: "CloseTab",
          params: {},
        };
        that.tabUpdateEvent.emit(tabObj);
      }
    });
  }

  loadeditJGRNList() {
    let params = {
      jgrn_id: this.jgrnData.jgrn_id,
    };
    this.jgrn.getEditJGRNList(params).then((res: any) => {
      this.data.jgrnList = res.data;
      // this.calcTotal();
      // this.calcQty();
    });
  }
}

/*  onClickCode(party_code) {
        let partyCodeList = _.filter(this.codeList, { code: party_code });
        this.partyCodeList = partyCodeList;
        let poNoList = _.filter(this.poList, { party_code: party_code });
        this.poNoList = poNoList;
    }
    onClickParty(party_name) {
        let LRList = _.filter(this.lrList, { party_name: party_name });
        this.LRList = LRList;
    }
    onClickLr(lr_no) {
        if (lr_no != '') {
            let invList = _.filter(this.lrList, { lr_no: lr_no });
            this.invList = invList;
            this.JGRNData['lr_date'] = invList[0]['lr_date'];
            this.JGRNData.lr_y_date = invList[0]['lr_date'];
            this.JGRNData['lr_amnt'] = invList[0]['lr_amount'];
            this.JGRNData['lr_id'] = invList[0]['plr_id'];
            this.JGRNData.pvt_mark = invList[0]['pvt_mark'];
            this.calcDiff();
            this.calcLCrate();
        }
        else {
            this.JGRNData.lr_y_date = '';
            this.JGRNData['lr_amnt'] = '';
        }


    }

    calcLCrate(){
        for(let i=0;i<this.data.JGRNList.length;i++){
        let cooly = this.JGRNData['no_of_bundle'] * 30;
        let bundlepercooly = this.JGRNData['cooly_amt'] /cooly;
        if(isNaN(bundlepercooly)){
            bundlepercooly = 0;
        }
        let totalrate=0;
        totalrate = this.JGRNData['taxinvamount'] + this.JGRNData['freight_charges'] + this.JGRNData['othersamt']+ this.JGRNData['lr_amnt'] + bundlepercooly;
        this.data.JGRNList[i].lc_per = totalrate /this.JGRNData['totalinvamt'] * 100;
        this.data.JGRNList[i].lc_per = Math.round(this.data.JGRNList[i].lc_per).toFixed(2);
       
        this.JGRNData['lc_per'] = this.data.JGRNList[i].lc_per;
       
        }
        
        return this.data.JGRNList;
    }

    onClickInv(invoice_no) {
        if (invoice_no != '') {
            let invDate = _.filter(this.lrList, { invoice_no: invoice_no });
            this.JGRNData['inv_date'] = invDate[0]['invoice_date'];
            this.JGRNData['inv_y_date'] = invDate[0]['invoice_date'];
            this.JGRNData['inv_amnt'] = invDate[0]['grand_total'];
            this.JGRNData['inv_id'] = invDate[0]['inv_id'];
            this.JGRNData['freight_charges'] = invDate[0]['freight_charge'];
            this.JGRNData['no_of_bundle'] = invDate[0]['no_of_bundle'];
            this.JGRNData['cooly_amt'] = invDate[0]['cooly_amt'];
            this.JGRNData['othersamt'] = invDate[0]['others'];
            this.JGRNData['taxinvamount'] = invDate[0]['tax_amount'];
            this.JGRNData['totalinvamt'] = invDate[0]['totalamt'];
        }
        else {
            this.JGRNData['inv_y_date'] = '';
            this.JGRNData['inv_amnt'] = '';
        }
    }
    onClickDesign(designno, ind) {
        //  let designData =  _.filter(this.designList, { design_no: designno });

        //   this.data.JGRNList[ind].des_no = designData[0]['design_no'];
        //      this.data.JGRNList[ind].design_shade = designData[0]['design_shade'];
        let des_no = this.data.JGRNList[ind].des_no;
        let design_shade = this.data.JGRNList[ind].pd_code;
        for (let i = 0; i < this.data.JGRNList.length; i++) {
            if (i != ind && designno == this.data.JGRNList[i].des_no) {
                let design_no = this.data.JGRNList[i].design_no;
                this.data.JGRNList[ind].design_no = design_no;
                return;
            }
        }
        this.generateOdNo(des_no, ind, design_shade);
    }
    onclickpdcode(designshade, ind) {
        let designData = _.filter(this.designList, { design_shade: designshade });
        this.data.JGRNList[ind].des_no = designData[0]['design_no'];
        this.data.JGRNList[ind].p_shade = designData[0]['shade']; */
/* if(typeof this.data.JGRNList[ind].des_no == 'number'){
            this.type = 'NEW';
            this.onClickDesign(this.data.JGRNList[ind].des_no,ind);
            console.log(this.type);
        }
        else{
            this.type ='CORE';
              let params = {
                pdesign_no: this.data.JGRNList[ind].des_no,
      }; 
              this.JGRN
                .getCoreList(params)
                   .then((res: any) => {
  
                     this.data.JGRNList[ind].design_no = res;
                     console.log(this.type);
  
          });
            
        }*/
/* 
        let params = {
            pdesign_no: this.data.JGRNList[ind].des_no,
            shade: this.data.JGRNList[ind].p_shade,
        };
        this.JGRN
            .getCoreList(params)
            .then((res: any) => {
                if (res.success == true) {
                    this.data.JGRNList[ind].design_type = "CORE";
                    this.data.JGRNList[ind].design_no = res.data[0]['core_designno'];
                    this.data.JGRNList[ind].shade = res.data[0]['shade'];
                    console.log(this.type);
                }
                else {
                    this.data.JGRNList[ind].design_type = "NEW";
                    this.onClickDesign(this.data.JGRNList[ind].des_no, ind);
                }
            });
    }
    getDesign(po_no) {
        let params = {
            po_no: this.JGRNData.po_no,
        }
        this.JGRN
            .getDesign(params)
            .then((res: any) => {

                this.designList = res.data;
                if (this.mode == "Edit") {
                    this.partyCtrl.setValue(this.designdata['party_name']);
                }

            });
    }
    onEnterpono(pono) {
        if (pono != '') {
            let params = {
                po_no: pono
            }
            let that = this;
            this.JGRN
                .getDesignno(params)
                .then((res: any) => {
                    if (res.data.length > 0) {
                        that.designnoList = res.data;
                        that.JGRNData.party_code = res.data[0].party_code;
                        that.JGRNData['po_id'] = res.data[0].po_id;
                        that.JGRNData['po_date'] = res.data[0]['po_date'];
                        that.JGRNData.party_name = res.data[0].party_name;
                        that.JGRNData.party_id = res.data[0].party_id; */
// that.calcDiff();
//that.JGRNData['diff_days'] = ((parseInt(that.JGRNData['grn_date']) - that.JGRNData['po_date']) / (1000 * 60 * 60 * 24));
//  that.OnclickPartyCode(that.JGRNData.party_code);
/*  }
                    else {
                        this.JGRNData.party_code = '',
                            this.JGRNData['po_id'] = '',
                            this.JGRNData.party_name = '',
                            this.JGRNData['po_date'] = '',
                            this.JGRNData['diff_days'] = ''
                        this.toasterService.pop({
                            bodyOutputType: 1,
                            type: 'error',
                            title: 'Please Enter the valid Po.no'
                        });
                    }

                });
        }
        else {
            this.JGRNData.party_code = '',
                this.JGRNData['po_id'] = '',
                this.JGRNData.party_name = '',
                this.JGRNData['po_date'] = '',
                this.JGRNData['diff_days'] = '';
            this.toasterService.pop({
                bodyOutputType: 1,
                type: 'error',
                title: 'Please Enter the valid Po.no'
            });
        }

    }
  
   
   
 */



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jgrn/AddEditJGRN.ts